import { render, staticRenderFns } from "./AssetCode.vue?vue&type=template&id=28da8439&"
import script from "./AssetCode.vue?vue&type=script&lang=js&"
export * from "./AssetCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports